import { css } from "@emotion/css";

import { _GoogleLogo } from "./_GoogleLogo";

export function _GoogleFooter() {
  return (
    <div className={styles.footer}>
      <_GoogleLogo />
    </div>
  );
}

const styles = {
  footer: css({
    display: "flex",
    paddingTop: "var(--space-2-5)",
    paddingLeft: "var(--space-3)",
    paddingBottom: "var(--space-2-5)",
    paddingRight: "var(--space-3)",
  }),
};
